import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { certPowershell } from './certPowershell';
import { delegatedRedirectUri } from '../../api/sharepointAPI';

// Značky použité v preložených textoch návodu (global.json, kľúče delegatedHelp* / spHelp*).
const TAGS = { strong: <strong />, em: <em />, code: <code /> };

// Návod pre delegované prihlásenie (OAuth 2.0 – On behalf of user). Zrkadlí CertHelpModal.
const DelegatedHelpModal = ({ open, onClose }) => {
  const [t] = useTranslation('global');
  const [copiedPs, setCopiedPs] = useState(false);
  const [copiedUri, setCopiedUri] = useState(false);
  const tr = (key) => <Trans t={t} i18nKey={key} components={TAGS} />;
  const certPs = certPowershell(t('spHelpPsPassword'));

  const copyPs = async () => {
    try {
      await navigator.clipboard.writeText(certPs);
      setCopiedPs(true);
      window.setTimeout(() => setCopiedPs(false), 1500);
    } catch (e) { /* clipboard nedostupný — ignoruj */ }
  };
  const copyUri = async () => {
    try {
      await navigator.clipboard.writeText(delegatedRedirectUri);
      setCopiedUri(true);
      window.setTimeout(() => setCopiedUri(false), 1500);
    } catch (e) { /* clipboard nedostupný — ignoruj */ }
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="sp-deleg-help-title">
      <div className="env-modal sp-help-modal">
        <div className="new-env-title">
          <h1 id="sp-deleg-help-title">{t('delegatedHelpTitle')}</h1>
        </div>

        <div className="sp-help-body">
          <p className="sp-help-intro">{tr('delegatedHelpIntro')}</p>

          <ol className="sp-help-steps">
            <li>
              <strong>{t('spHelpRegisterTitle')}</strong>
              <span>{tr('delegatedHelpRegisterText1')}</span>
              <ul className="sp-help-fields">
                <li>{tr('delegatedHelpRegName')}</li>
                <li>{tr('delegatedHelpRegRedirect')}</li>
              </ul>
              <span>{tr('delegatedHelpRegisterText2')}</span>
              <span className="sp-help-note">{tr('delegatedHelpUpnNote')}</span>
            </li>

            <li>
              <strong>{t('delegatedHelpSaveTitle')}</strong>
              <span>{tr('delegatedHelpSaveText1')}</span>
              <span>{tr('delegatedHelpSaveText2')}</span>
              <span className="sp-help-note">{tr('spHelpSameApp')}</span>

              <details className="sp-help-detail">
                <summary><strong>{t('spHelpManualPs')}</strong><span className="sp-help-tag simple">{t('spHelpAlternative')}</span></summary>
                <div className="sp-help-detail-body">
                  <p>{tr('spHelpPsIntro')}</p>
                  <div className="sp-help-code-wrap">
                    <button type="button" className="sp-help-copy" onClick={copyPs}>
                      <span className="material-symbols-outlined">{copiedPs ? 'check' : 'content_copy'}</span>
                      {copiedPs ? t('copied') : t('copy')}
                    </button>
                    <pre className="sp-help-code">{certPs}</pre>
                  </div>
                  <div className="sp-help-callout">
                    <div><span className="sp-file-tag cer">.cer</span> {tr('spHelpCerFile')}</div>
                    <div><span className="sp-file-tag pfx">.pfx</span> {tr('spHelpPfxFile')}</div>
                  </div>
                </div>
              </details>
            </li>

            <li>
              <strong>{t('spHelpUploadCertTitle')}</strong>
              <span>{tr('delegatedHelpUploadText')}</span>
            </li>

            <li>
              <strong>{t('delegatedHelpRedirectTitle')}</strong>
              <span>{tr('delegatedHelpRedirectText')}</span>
              <div className="sp-help-code-wrap">
                <button type="button" className="sp-help-copy" onClick={copyUri}>
                  <span className="material-symbols-outlined">{copiedUri ? 'check' : 'content_copy'}</span>
                  {copiedUri ? t('copied') : t('copy')}
                </button>
                <pre className="sp-help-code">{delegatedRedirectUri}</pre>
              </div>
              <span className="sp-help-note">{tr('delegatedHelpRedirectNote')}</span>
            </li>

            <li>
              <strong>{t('delegatedHelpPermTitle')}</strong>
              <span>{tr('delegatedHelpPermText')}</span>
            </li>

            <li>
              <strong>{t('delegatedHelpSignInTitle')}</strong>
              <span>{tr('delegatedHelpSignInText')}</span>
            </li>

            <li>
              <strong>{t('spHelpTestTitle')}</strong>
              <span>{tr('spHelpTestText')}</span>
            </li>
          </ol>

          <details className="sp-help-detail sp-help-troubleshoot">
            <summary><strong>{t('delegatedHelpTroubleshoot')}</strong><span className="sp-help-tag simple">{t('delegatedHelpCommonIssues')}</span></summary>
            <div className="sp-help-detail-body">
              <p>{tr('delegatedHelpIssue401')}</p>
              <p>{tr('delegatedHelpIssueCert')}</p>
              <p>{tr('delegatedHelpIssueReply')}</p>
              <p>{tr('delegatedHelpIssuePublic')}</p>
            </div>
          </details>
        </div>

        <div className="sp-modal-footer">
          <button type="button" className="submit-button" onClick={onClose}>{t('close')}</button>
        </div>
      </div>
    </Modal>
  );
};

export default DelegatedHelpModal;
